import storage from './storage'
let api = null

let imageDomain= 'https://media.thedatingmessenger.com'
// Code inside this check is stripped off when not on localhost
if (process.env.NODE_ENV !== 'production') {
  // please also update the options in src/pages/Playground.js
  const environment = (process.env && process.env.NODE_ENV.indexOf('development') >= 0) ? 'dev' : storage.get('SERVER_ENV', 'staging')
  switch(environment) {
    case 'production':
      api = 'https://api.thedatingmessenger.com'
      break
    case 'staging':
      api = 'https://api.staging.thedatingmessenger.com'
      break
    case 'dev':
      api = 'http://ccp-api.dev.starcoders.com'
      break
    default:
      api = '/api'
  }
  imageDomain = 'https://media.staging.thedatingmessenger.com'
}

export { api, imageDomain }
